import Dexie from 'dexie';

const db = new Dexie('fsm_db');
db.version(1).stores({
    visits: 'id,date',
    materials: 'name'
});

export default db;


// WEBPACK FOOTER //
// ./src/components/localDb.js